import cx from "classnames";
import React from "react";

import {
    aboutPrivacyPolicyUrl,
    aboutRulesCommonUrl,
    aboutRulesMarketUrl,
    modrykonikPrivacyPolicyLinkLabel,
} from "@/mk2/apps/about/urls";
import { homepageUrl } from "@/mk2/apps/home/urls";
import { SignupLoginTabs } from "@/mk2/apps/users/components/SignupLoginTabs";
import { SocialAuthButtons } from "@/mk2/apps/users/components/SocialAuthButtons";
import { QueryParams as LoginQueryParams } from "@/mk2/apps/users/containers/Login/LoginPage";
import { QueryParams as SignupQueryParams } from "@/mk2/apps/users/containers/Signup/SignupPage";
import { Img } from "@/mk2/components/Img";
import { Interpolate } from "@/mk2/components/Interpolate";
import { Link } from "@/mk2/components/Link";
import { LoadingPlaceholder } from "@/mk2/components/LoadingPlaceholder";
import { RenderAST } from "@/mk2/components/RenderAST";
import Sticker, { StickerSize } from "@/mk2/components/Sticker";
import { FormPageType } from "@/mk2/constants/enums";
import InstallPrompt from "@/mk2/containers/InstallPrompt/InstallPrompt";
import { ShowPhotosAndVideos } from "@/mk2/helpers/article_ast/filters";
import { GetParams } from "@/mk2/helpers/urls";
import { ContentItemEntity } from "@/mk2/schemas";
import { HistoryLocationWithState } from "@/mk2/services/browserHistory";
import {
    HOMEPAGE_HEADING,
    HOMEPAGE_PARA_1_CONTENT,
    HOMEPAGE_PARA_1_HEADING,
    HOMEPAGE_PARA_2_CONTENT,
    HOMEPAGE_PARA_2_HEADING,
    HOMEPAGE_PARA_3_CONTENT,
    HOMEPAGE_PARA_3_HEADING,
    HOME_SIGNUP_BAZAAR,
    HOME_SIGNUP_I_AGREE_WITH_SITE_RULES_bazaar_link_common_link_privacy_link,
    HOME_SIGNUP_PRIVACY,
    HOME_SIGNUP_VOP,
} from "@/mk/autogenerated/translations/SignupLoginWrapper.0f963a8e53b62c70ca66a6befcf496d6";
import assetUrl from "@/mk/common/assetUrl";
import { ACTIVE_SERVER_ID } from "@/mk/settings";

import styles from "./SignupLoginWrapper.mscss";

interface OwnProps {
    className?: string;
    query: LoginQueryParams | SignupQueryParams;
    isMobile: boolean;
    currentFormPage: FormPageType;
    location: HistoryLocationWithState;
    mode?: "signup" | "login";

    contentItemsKey?: string;
    contentItemBottom?: ContentItemEntity;
    contentItemTop?: ContentItemEntity;
}

type Props = OwnProps;

export class SignupLoginWrapper extends React.Component<Props> {
    public render() {
        const {
            query,
            children,
            className,
            isMobile,
            currentFormPage,
            location,
            mode,
            contentItemsKey,
            contentItemTop,
            contentItemBottom,
        } = this.props;

        return (
            <div className={cx(styles.SignupLoginWrapper, className)}>
                <div className={styles.SignupLoginWrapper__wrapper}>
                    {isMobile && contentItemsKey && (contentItemTop || !contentItemBottom) && (
                        <div className={styles.SignupLoginWrapper__contentItemTop}>
                            {contentItemTop ? (
                                <RenderAST
                                    contentAST={contentItemTop.contentAST}
                                    linkedObjects={
                                        contentItemTop.contentASTAdditionalData.linkedObjects
                                    }
                                    showPhotosAndVideos={ShowPhotosAndVideos.ALL}
                                    renderSpecialWikiLinks={false}
                                    photos={contentItemTop.photos}
                                    allowSubstitutingGetParams={query as unknown as GetParams}
                                />
                            ) : (
                                ContentItemPlaceholder
                            )}
                        </div>
                    )}

                    <div className={styles.SignupLoginWrapper__form}>
                        {!isMobile && (
                            <Link
                                className={styles.SignupLoginWrapper__logo}
                                to={homepageUrl}
                                data-google-interstitial="false"
                            >
                                <Img
                                    src={assetUrl + "img/logos/ver-3/logo-201@2x.png"}
                                    width={160}
                                    height={36}
                                />
                            </Link>
                        )}

                        {!isMobile && currentFormPage === FormPageType.Main && (
                            <SignupLoginTabs query={query} location={location} />
                        )}

                        {currentFormPage === FormPageType.Main && (
                            <SocialAuthButtons mode={mode || "signup"} location={location} />
                        )}

                        {children /* the form */}

                        {!isMobile && (
                            <Sticker
                                className={styles.SignupLoginWrapper__sticker}
                                id={1}
                                size={StickerSize.XL}
                            />
                        )}
                    </div>

                    {isMobile && contentItemsKey && (contentItemBottom || !contentItemTop) && (
                        <div className={styles.SignupLoginWrapper__contentItemBottom}>
                            {contentItemBottom ? (
                                <RenderAST
                                    contentAST={contentItemBottom.contentAST}
                                    linkedObjects={
                                        contentItemBottom.contentASTAdditionalData.linkedObjects
                                    }
                                    showPhotosAndVideos={ShowPhotosAndVideos.ALL}
                                    renderSpecialWikiLinks={false}
                                    photos={contentItemBottom.photos}
                                    allowSubstitutingGetParams={query as unknown as GetParams}
                                />
                            ) : (
                                ContentItemPlaceholder
                            )}
                        </div>
                    )}

                    {!isMobile ? (
                        <div className={styles.SignupLoginWrapper__content_wrapper}>
                            {contentItemsKey && (contentItemTop || !contentItemBottom) && (
                                <div className={styles.SignupLoginWrapper__contentItemTop}>
                                    {contentItemTop ? (
                                        <RenderAST
                                            contentAST={contentItemTop.contentAST}
                                            linkedObjects={
                                                contentItemTop.contentASTAdditionalData
                                                    .linkedObjects
                                            }
                                            showPhotosAndVideos={ShowPhotosAndVideos.ALL}
                                            renderSpecialWikiLinks={false}
                                            photos={contentItemTop.photos}
                                            allowSubstitutingGetParams={
                                                query as unknown as GetParams
                                            }
                                            customStyles={{
                                                header2: styles.SignupLoginWrapper__content__header,
                                            }}
                                        />
                                    ) : (
                                        ContentItemPlaceholder
                                    )}
                                </div>
                            )}

                            {!contentItemsKey && (
                                <>
                                    <div className={styles.SignupLoginWrapper__yt_video}>
                                        <Img
                                            src={assetUrl + "img/homepage/variant-b/main-2.png"}
                                            width={600}
                                            height={338}
                                        />
                                    </div>

                                    <div className={styles.SignupLoginWrapper__content}>
                                        <h1>{HOMEPAGE_HEADING}</h1>

                                        <div className={styles.SignupLoginWrapper__content_box}>
                                            <Img
                                                src={assetUrl + "img/homepage/friends@2x.png"}
                                                width={80}
                                                height={80}
                                            />
                                            <div
                                                className={
                                                    styles.SignupLoginWrapper__content_box__text
                                                }
                                            >
                                                <h2>{HOMEPAGE_PARA_1_HEADING}</h2>
                                                <p>{HOMEPAGE_PARA_1_CONTENT}</p>
                                            </div>
                                        </div>

                                        <div className={styles.SignupLoginWrapper__content_box}>
                                            <Img
                                                src={assetUrl + "img/homepage/messaging@2x.png"}
                                                width={80}
                                                height={80}
                                            />
                                            <div
                                                className={
                                                    styles.SignupLoginWrapper__content_box__text
                                                }
                                            >
                                                <h2>{HOMEPAGE_PARA_2_HEADING}</h2>
                                                <p>{HOMEPAGE_PARA_2_CONTENT}</p>
                                            </div>
                                        </div>

                                        <div className={styles.SignupLoginWrapper__content_box}>
                                            <Img
                                                src={assetUrl + "img/homepage/stroller@2x.png"}
                                                width={80}
                                                height={80}
                                            />
                                            <div
                                                className={
                                                    styles.SignupLoginWrapper__content_box__text
                                                }
                                            >
                                                <h2>{HOMEPAGE_PARA_3_HEADING}</h2>
                                                <p>{HOMEPAGE_PARA_3_CONTENT}</p>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {contentItemsKey && (contentItemBottom || !contentItemTop) && (
                                <div className={styles.SignupLoginWrapper__contentItemBottom}>
                                    {contentItemBottom ? (
                                        <RenderAST
                                            contentAST={contentItemBottom.contentAST}
                                            linkedObjects={
                                                contentItemBottom.contentASTAdditionalData
                                                    .linkedObjects
                                            }
                                            showPhotosAndVideos={ShowPhotosAndVideos.ALL}
                                            renderSpecialWikiLinks={false}
                                            photos={contentItemBottom.photos}
                                            allowSubstitutingGetParams={
                                                query as unknown as GetParams
                                            }
                                        />
                                    ) : (
                                        ContentItemPlaceholder
                                    )}
                                </div>
                            )}
                        </div>
                    ) : (
                        currentFormPage === FormPageType.Main && (
                            <>
                                <InstallPrompt />
                                <div className={styles.SignupLoginWrapper__fixedToBottom}>
                                    <Interpolate
                                        i18nKey={
                                            HOME_SIGNUP_I_AGREE_WITH_SITE_RULES_bazaar_link_common_link_privacy_link
                                        }
                                        bazaar_link={
                                            <Link
                                                to={aboutRulesMarketUrl}
                                                target="_blank"
                                                className={
                                                    styles.SignupLoginWrapper__fixedToBottom__link
                                                }
                                            >
                                                {HOME_SIGNUP_BAZAAR}
                                            </Link>
                                        }
                                        common_link={
                                            <Link
                                                to={aboutRulesCommonUrl}
                                                target="_blank"
                                                className={
                                                    styles.SignupLoginWrapper__fixedToBottom__link
                                                }
                                            >
                                                {HOME_SIGNUP_VOP}
                                            </Link>
                                        }
                                        privacy_link={
                                            <>
                                                <Link
                                                    to={aboutPrivacyPolicyUrl}
                                                    target="_blank"
                                                    className={
                                                        styles.SignupLoginWrapper__fixedToBottom__link
                                                    }
                                                >
                                                    {modrykonikPrivacyPolicyLinkLabel}
                                                </Link>
                                            </>
                                        }
                                    />
                                </div>
                                <div
                                    className={styles.SignupLoginWrapper__fixedToBottomPlaceholder}
                                />
                            </>
                        )
                    )}
                </div>
            </div>
        );
    }
}

const ContentItemPlaceholder = (
    <>
        <LoadingPlaceholder width={170} height={30} style={{ marginTop: 20, marginBottom: 20 }} />
        <LoadingPlaceholder width={"100%"} height={110} style={{ marginBottom: 20 }} />
    </>
);
